export default "__VITE_ASSET__uCL1C9i4__"